import './EyeBadge.css';

// The logo's eye, glancing around and winking while a reply is on its way -
// the same waiting indicator as the VS Code extension (media/chat.js).
export default function EyeBadge({ label, size = 26 }) {
  return (
    <span className="eye-badge" role="img" aria-label={label} style={{ width: size, height: size }}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <g className="eye-badge-lid">
          <path
            d="M2 12 C5.5 5.5 18.5 5.5 22 12 C18.5 18.5 5.5 18.5 2 12 Z"
            fill="none"
            stroke="#fff"
            strokeWidth="2.2"
            strokeLinejoin="round"
          />
          <circle className="eye-badge-pupil" cx="12" cy="12" r="3.6" fill="#fff" />
        </g>
      </svg>
    </span>
  );
}
